import { Terminal } from './components/Terminal';

export default function App() {
  return (
    <div className='min-h-screen w-full bg-[#0a0a0a] flex items-center justify-center p-4 md:p-8'>
      <Terminal />
    </div>
  );
}
